<div class="modal fade" id="capeModal" tabindex="-1" role="dialog" aria-labelledby="capeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="capeModalLabel">CAPE Açıklama Tablosu</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="alert alert-info">CAPE Nedir? (Basit Anlatım)
          CAPE, atmosferdeki bir hava paketinin ne kadar yukarı doğru yükselebileceğini ve ne kadar enerjiyle
          yükseldiğini gösteren bir ölçüdür.
          Birimi: Joule / kilogram (J/kg)</div>
        <div class="table-responsive">
          <table class="table table-bordered table-striped table-sm text-center align-middle">
            <thead class="table-light">
              <tr>
                <th scope="col">CAPE (J/kg)</th>
                <th scope="col">Anlamı</th>
                <th scope="col">Paragliding Yorumu</th>
                <th scope="col">Fırtına Riski</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0 – 100</td>
                <td>Durağan hava</td>
                <td>Termik zayıf, uçuş kısa olabilir</td>
                <td>Yok</td>
              </tr>
              <tr>
                <td>100 – 500</td>
                <td>Hafif kararsız</td>
                <td>Zayıf termikler, kısa soaring mümkün</td>
                <td>Çok düşük</td>
              </tr>
              <tr>
                <td>500 – 1000</td>
                <td>Orta kararsızlık</td>
                <td>Termikler destekleyici</td>
                <td>Düşük</td>
              </tr>
              <tr>
                <td>1000 – 2000</td>
                <td>Güçlü kararsızlık</td>
                <td>Yüksek irtifa ve XC potansiyeli</td>
                <td>Orta – Dikkatli olun</td>
              </tr>
              <tr class="table-danger fw-bold">
                <td>&gt;2000</td>
                <td>Çok güçlü enerji</td>
                <td>Güçlü türbülans, fırtına riski!</td>
                <td><strong>Yüksek ⚠️</strong></td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="ccbModal" tabindex="-1" role="dialog" aria-labelledby="ccbModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ccbModalLabel">Termik Bulut Tabanı Açıklama</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="alert alert-info">
          <div class="mb-4">
            <h5 class="fw-bold">Convective Cloud Base (Basit Tanım)</h5>
            <p>
              Convective Cloud Base, yüzeydeki güneş ısısıyla yükselen sıcak hava paketlerinin (termiklerin) havada
              yoğuşarak bulut oluşturduğu yüksekliktir.
            </p>
            <p>
              Yani bu: <em>"Güneş ısıtırsa, termik çıkarsa, bulut nerede başlar?"</em> sorusunun cevabıdır.
            </p>
            <p><strong>Birimi genellikle:</strong> metre veya hPa (örneğin: <code>1450 m</code> veya
              <code>850 hPa</code>)
            </p>
          </div>

          <div class="mb-4">
            <h6 class="fw-bold">🪂 Pilotlar için Anlamı</h6>
            <ul>
              <li>Termikler çalışıyorsa ve nem yeterliyse, bu seviyede <strong>cumulus bulutları</strong> (pamuk
                bulutlar)
                oluşabilir.</li>
              <li>Bu seviye genellikle, uçuş sırasında <strong>bulut altına kadar çıkılabilecek maksimum
                  irtifayı</strong>
                gösterir.</li>
              <li>Eğer bu yükseklik yeterince yüksekse, <strong>termal uçuş ve XC uçuşu</strong> için iyi bir potansiyel
                vardır.</li>
            </ul>
            <h6 class="fw-bold">Bulut kapalılık oranı %80, fakat Termik Bulut Tabanı yok! — neden olur?</h6>
            <p>Gökyüzünde bulutlar görünse de, bunlar güneşin yüzeyi ısıtmasıyla yükselen termiklerle oluşmamıştır.
              Yani, bu bulutlar 'konvektif' değil; başka atmosferik süreçlerle, örneğin nemli havanın yükselmeden
              soğuması veya cephe geçişleri gibi durumlarla oluşmuştur."</p>
          </div>


        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
        </div>
      </div>
    </div>
  </div>
</div>



<div class="modal fade" id="tIModal" tabindex="-1" role="dialog" aria-labelledby="tILabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="tILabel">850hPa Termik İndeksi Açıklaması</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          <h5 class="fw-bold">🌡️ 1500 m Termik İndeksi Nedir?</h5>
          <p>
            Termik İndeksi, yükselen bir hava paketinin çevresine göre ne kadar sıcak veya soğuk olduğunu gösterir.
            <strong>850 hPa</strong> seviyesi, deniz seviyesinden yaklaşık <strong>1500–1600 metre</strong> yüksekliğe
            karşılık gelir.
          </p>
        </div>

        <div class="mb-4">

          <p><strong>1500 m Termik İndeksi</strong>, <em>“termikler bu seviyeye kadar kolayca çıkabilir mi?”</em>
            sorusunun cevabını verir.</p>

          <div class="row">
            <div class="col-md-6">
              <p class="mb-1 fw-semibold text-success">🔻 Değerler negatif ise:</p>
              <ul>
                <li>Yükselen hava çevresine göre daha <strong>sıcak</strong></li>
                <li>Termik <strong>güçlü</strong>, irtifa kazanma <strong>kolay</strong></li>
              </ul>
            </div>
            <div class="col-md-6">
              <p class="mb-1 fw-semibold text-danger">🔺 Değerler pozitif ise:</p>
              <ul>
                <li>Yükselen hava çevresine göre daha <strong>soğuk</strong></li>
                <li>Termik <strong>zayıf</strong> veya <strong>bastırılmış</strong>, zor irtifa kazanılır</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="mb-4">
          <h6 class="fw-bold">📏 Değerlerin Yorumu</h6>
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-sm text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th>Termik İndeksi<br>(1500 m)</th>
                  <th>Termik İndeksi<br>(3000 m)</th>
                  <th>Anlamı</th>
                  <th>Uçuş Yorumu</th>
                </tr>
              </thead>
              <tbody>
                <tr style="background-color: rgba(255, 0, 0, 0.5);">
                  <td>≤ -6</td>
                  <td>≤ -6</td>
                  <td>Çok güçlü termik</td>
                  <td>Çok sert ve türbülanslı hava, yüksek irtifa, dikkat!</td>
                </tr>
                <tr style="background-color: rgba(248, 162, 101, 0.5);">
                  <td>-4 ile -6 arası</td>
                  <td style="background-color: rgba(214, 101, 248, 0.5);">-4 ile -6 arası</td>
                  <td>Güçlü termik</td>
                  <td>Verimli ve uzun uçuşlar, güçlü yükselişler</td>
                </tr>
                <tr style="background-color: rgba(153, 184, 252, 0.5);">
                  <td>0 ile -4 arası</td>
                  <td style="background-color: rgba(217, 255, 0, 0.73);">0 ile -4 arası</td>
                  <td>Orta düzey termik</td>
                  <td>Termikler var ama dikkatli olunmalı, bazı alanlarda zayıflayabilir</td>
                </tr>
                <tr style="background-color: rgba(255, 255, 255, 0.5);">
                  <td>0 ile +2 arası</td>
                  <td>0 ile +2 arası</td>
                  <td>Zayıf termik</td>
                  <td>Kısa uçuşlar, lift az, yelken varsa değerlendirilebilir</td>
                </tr>
                <tr style="background-color: rgba(200, 200, 200, 0.5);">
                  <td>+2 ve üzeri</td>
                  <td>+2 ve üzeri</td>
                  <td>Stabil hava</td>
                  <td>Termik yok, sadece yelken varsa uçuş mümkün</td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>

        <div class="alert alert-warning">
          💡 <strong>Not:</strong> Bu indeks <em>tek başına yeterli değildir</em>; <strong>nem, yüzey
            ısınması</strong> ve <strong>CAPE</strong> gibi diğer verilerle birlikte değerlendirilmelidir.<br />
          Yine de <strong>1500 m TI</strong>, gün içindeki termik potansiyelini öngörmek için çok pratik bir
          göstergedir.
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-----------Wind-->
<div class="modal fade" id="windModal" tabindex="-1" role="dialog" aria-labelledby="windModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="windModalLabel">Rüzger Yönü Açıklama</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          <h5 class="fw-bold">💨 Rüzgar Yönü – Basit Anlatım</h5>
          <p>
            Rüzgar yönü, <strong>rüzgarın geldiği yönü</strong> ifade eder. Örneğin, rüzgar "K" yani Kuzey yönünden
            esiyorsa,
            bu rüzgar <em>kuzeyden güneye doğru</em> esiyor demektir.
          </p>
          <p>
            Rüzgar yönü, genellikle <strong>0° ile 360°</strong> arasındaki bir dereceyle ifade edilir ve bu değerler
            pusula yönlerine çevrilir. Aşağıdaki örnekler yaygındır:
          </p>
          <ul>
            <li><strong>K (0°)</strong> – Kuzeyden esen rüzgar</li>
            <li><strong>D (90°)</strong> – Doğudan esen rüzgar</li>
            <li><strong>G (180°)</strong> – Güneyden esen rüzgar</li>
            <li><strong>B (270°)</strong> – Batıdan esen rüzgar</li>
          </ul>
          <p>
            Daha hassas değerlendirme için <strong>16 yönlü pusula sistemi</strong> kullanılır:
            <span class="fst-italic">KKD, DKD, GGB, BKB</span> gibi. Bu sistem, rüzgarın yönünü daha detaylı anlamamızı
            sağlar.
          </p>
        </div>
        <div class="text-center my-3">
          <img src="assets/images/windRose.png" alt="Rüzgar Gülü" class="img-fluid rounded shadow-sm"
            style="max-width: 320px;">
          <div class="small text-muted mt-2">16 yönlü rüzgar gülü görseli</div>
        </div>

        <div class="alert alert-info">
          🪂 <strong>Paragliding için:</strong> Kalkış alanının yönü ile rüzgar yönü uyumluysa, kalkış daha güvenli ve
          verimli olur.
          <br />
          Rüzgar <strong>arkadan (tailwind)</strong> geliyorsa, kalkış <span class="text-danger fw-bold">riskli</span>
          hale gelir.
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>

<!----------Humidity-->
<div class="modal fade" id="humidityModal" tabindex="-1" role="dialog" aria-labelledby="humidityModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="humidityModalLabel">Rüzger Yönü Açıklama</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          <h5 class="fw-bold">💧 1500 m ve 3000 m Bağıl Nem, Çiy Noktası ve Yağış Olasılığı</h5>
          <p>
            <strong>850 hPa seviyesi:</strong> Yaklaşık <code>1500 metre</code> <br />
            <strong>700 hPa seviyesi:</strong> Yaklaşık <code>3000 metre</code>
          </p>
          <p>
            <strong>Bağıl nem (RH):</strong> Havanın içerdiği nem oranı<br />
            <strong>Çiy Noktası (Dew Point):</strong> Havanın doygun hale gelip yoğuşmaya başladığı sıcaklık<br />
            <strong>Sıcaklık – Çiy Noktası farkı:</strong> Bu fark ne kadar küçükse, hava o kadar nemlidir ve
            bulut/yağış oluşumu o kadar olasıdır.
          </p>
        </div>

        <div class="mb-4">
          <h6 class="fw-bold">🪂 Pilotlar için Yorumu</h6>
          <ul class="mb-3">
            <li>
              <strong>1500 m RH ve Yoğuşma Sıcaklığı:</strong> Termiklerin ulaştığı seviyede bulut oluşma
              potansiyeli.<br />
              <span class="text-muted">→ Örnek: RH = %62, Çiy Noktası ≈ 6°C — Sıcaklıkla fark azsa bulutlanma
                mümkündür.</span>
            </li>
            <li>
              <strong>3000 m RH ve Yoğuşma Sıcaklığı:</strong> Bulutlar yükselip derinleşebilir mi?<br />
              <span class="text-muted">→ Örnek: RH = %72, Çiy Noktası ≈ -1°C — Yüksek nem + düşük sıcaklık = yağış
                olasılığı artar.</span>
            </li>
          </ul>
        </div>

        <div class="mb-4">
          <h6 class="fw-bold">🌧️ Yağış Olasılığı Nasıl Tahmin Edilir?</h6>
          <p>Yağmur oluşması için üç temel şart gerekir:</p>
          <ul>
            <li><strong>Yeterli CAPE:</strong> Havanın yükselmek için enerjisi</li>
            <li><strong>Yüksek bağıl nem (%60 üzeri):</strong> Havanın doygunlaşma potansiyeli</li>
            <li><strong>Çiy noktası sıcaklığa yakınsa:</strong> Yoğuşma başlar → bulutlar kalınlaşır → yağış olabilir
            </li>
          </ul>
          <p class="mb-2">
            <strong>Özellikle 3000 m'de</strong> çiy noktası ile sıcaklık farkı <code>2°C'den az</code> ise ve RH %80
            üzerindeyse:
          </p>
          <div class="border rounded p-3 bg-warning bg-opacity-25">
            <strong>“Bulutların tabanı doygun, tepesi nemli — yağış veya CB (gök gürültülü bulut) ihtimali
              vardır.”</strong>
          </div>
        </div>

        <div class="alert alert-secondary">
          <strong>📌 Özet:</strong><br />
          <em>
            “1500 ve 3000 m seviyelerindeki bağıl nem ve çiy noktası; sadece bulut değil, aynı zamanda <strong>yağmur
              ihtimalini</strong> de belirler.”<br />
            <strong>Termik = kaldırıcı güç</strong>, <strong>nem + çiy noktası = bulut ve yağış için
              ortam</strong><br />
            <strong>CAPE + nem + küçük sıcaklık-çiy noktası farkı = yağış ve CB riski</strong>
          </em>
        </div>



      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>
<!------------ECMWF cloud cover modal-------------->
<div class="modal fade" id="ecmwfCloudModal" tabindex="-1" role="dialog" aria-labelledby="ecmwfCloudModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="ecmwfCloudModalLabel">Bulut Seviyeleri Açıklama</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="mb-4">
          <h5 class="fw-bold">☁️ Bulut Seviyeleri (ECMWF Modeli)</h5>
          <p>
            ECMWF modeli bulutları üç ana katmanda sınıflandırır:
          </p>

          <div class="table-responsive mb-3">
            <table class="table table-bordered table-sm text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th>Seviye</th>
                  <th>Yükseklik Aralığı</th>
                  <th>Basit Açıklama</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Alçak Seviye Bulutlar</td>
                  <td>0 – 2 km<br><small>(~1000–800 hPa)</small></td>
                  <td>Yere en yakın bulutlardır. Genellikle kalkış ve iniş bölgelerinde görülür.</td>
                </tr>
                <tr>
                  <td>Orta Seviye Bulutlar</td>
                  <td>2 – 6 km<br><small>(~800–500 hPa)</small></td>
                  <td>Termiklerin ulaşabileceği seviyede, genellikle kümülüs ve altostratus türü bulutlar.</td>
                </tr>
                <tr>
                  <td>Yüksek Seviye Bulutlar</td>
                  <td>6 – 12 km<br><small>(~500–200 hPa)</small></td>
                  <td>Uçuş yüksekliğinin çok üzerinde; ince, buz kristalli sirüs bulutlarıdır. Genellikle termik
                    taşımazlar.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="mb-4">
          <h6 class="fw-bold">🪂 Pilotlar için Anlamı</h6>
          <div class="table-responsive">
            <table class="table table-bordered table-sm text-center align-middle">
              <thead class="table-light">
                <tr>
                  <th>Seviye</th>
                  <th>Ne Anlama Gelir?</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Alçak Bulutlar</td>
                  <td>Görüş mesafesini etkiler, kalkışta dikkat gerekir. Eğer yer seviyesine inerse sis olur.</td>
                </tr>
                <tr>
                  <td>Orta Seviye Bulutlar</td>
                  <td>Termikler burada bulut oluşturur. Genelde bulut tabanı (cloud base) bu seviyededir.</td>
                </tr>
                <tr>
                  <td>Yüksek Seviye Bulutlar</td>
                  <td>Genellikle görsel olarak güzel ama uçuşa etkisizdir. Ancak çok fazla olursa güneş ısısını keser,
                    termikler zayıflar.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="alert alert-secondary">
          <h6 class="fw-bold mb-2">💡 Örnek Yorum</h6>
          <ul class="mb-0">
            <li><strong>“Alçak bulut örtüsü %80”</strong> → Kalkış zor olabilir, görüş düşer</li>
            <li><strong>“Orta seviye bulutlar %40”</strong> → Termikler çalışıyor, bulut tabanı var</li>
            <li><strong>“Yüksek seviye bulutlar %100”</strong> → Sirüsler gökyüzünü kapatıyor, güneş zayıf, termik
              zayıflayabilir</li>
          </ul>
        </div>

      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Kapat</button>
      </div>
    </div>
  </div>
</div>
